module.exports = __webpack_public_path__ + "static/media/three_dot.e85a3cd7.svg";